module.exports = __webpack_public_path__ + "img/discount-tag-red.9f08bf36.svg";